import { Handle, Position, type NodeProps } from '@xyflow/react';
import { PhoneIncoming } from 'lucide-react';
import { NodeCard } from '../NodeCard';

/** Single fixed entry node — every IVR starts with this. Not removable. */
export function AnswerNode(props: NodeProps) {
  return (
    <>
      <NodeCard
        verb="answer"
        icon={PhoneIncoming}
        label="Answer"
        summary="Call answered"
        configurable={false}
        removable={false}
        status="configured"
        selected={props.selected}
      />
      <Handle
        type="source"
        position={Position.Right}
        className="!h-3 !w-3 !border-2 !border-white !bg-emerald-500"
      />
    </>
  );
}
